import { Card } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

import AnticipationToggle from "./anticipationToggle";
import CommercialInfoForm from "../commercialInfoForm";

type Props = {
  messages: T2PayHomeMessages;
};

function GeneralInfoField({ messages }: Props) {
  return (
    <Card>
      <MDBox p={3} display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2}>
        <MDTypography variant="h5">{messages.businessDataTitle}</MDTypography>
        <AnticipationToggle messages={messages} />
      </MDBox>

      <MDBox pb={3} px={3}>
        <CommercialInfoForm />
      </MDBox>
    </Card>
  );
}

export default GeneralInfoField;
